<template>
  <div id="simple-calendar-app">

    <Loader v-if="processing" cover/>
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        :events="calendarEventList"
        :show-date="showDate"
        :startingDayOfWeek="1"
        class="theme-default"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        @click-event="openEvent"
      >

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  class="cursor-pointer bg-primary text-white rounded-full"
                  svgClasses="w-5 h-5 m-1"
                  @click="updateMonth(-1)"/>

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDateFormat | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  class="cursor-pointer bg-primary text-white rounded-full"
                  svgClasses="w-5 h-5 m-1"
                  @click="updateMonth(1)"/>
              </div>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center">
              <div></div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-end order-last">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  class="p-3 md:px-8 md:py-3"
                  type="filled"
                  @click="calendarView = view.val"
                >{{ $t(`${view.i18n}`) }}
                </vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  class="p-3 md:px-8 md:py-3"
                  type="border"
                  @click="calendarView = view.val"
                >{{ $t(`${view.i18n}`) }}
                </vs-button>
              </template>

            </div>
          </div>

        </div>

        <div slot="dayContent" class="mb-5">
          <div slot="item" slot-scope="val" class="mb-5">
            {{ val }}
          </div>
        </div>

      </calendar-view>
    </div>
    <vx-card
      v-if="activeViewEvent"
      :button-close-hidden="true"
      :title="$t('advisor-online-schedule.detail-title')"
      class="view-event mt-base scroll-to-me">

      <h6 class="mb-4">
        {{ $t('live-class-schedule.topic') }}: {{ currentViewEvent.data.topicLocal }}
      </h6>
      <h6 class="mb-4">
        {{ $t('advisor-online-schedule.description') }}: {{ currentViewEvent.data.descriptionLocal }}
      </h6>

      <h6 class="mb-4">
        {{ $t('live-class-schedule.subject-code') }}: {{ currentViewEvent.data.subjectCode }}
        {{$t('class-overview.section')}} {{ currentViewEvent.data.classSection.sectionNo }}
        {{$t('class-overview.span')}} {{ currentViewEvent.data.classSection.learnSpanNo }}
      </h6>
      <h6 class="mb-4">
        {{ $t('live-class-schedule.subject-name') }}: {{ currentViewEvent.data.subjectName }}
      </h6>

      <h6>
        {{ $t('advisor-online-schedule.teacher') }}: {{ currentViewEvent.data.teacherFullName }}
      </h6>
      <vs-divider></vs-divider>
      <div class="flex justify-start flex-wrap">
          <span>
            <p class="text-xl mb-2">
              {{ $t('advisor-online-schedule.start-at') }} {{ currentViewEvent.startDateFormat }} - {{
                currentViewEvent.endDateFormat
              }}
            </p>
            <p class="text-grey">
              {{ $t('live-class-schedule.remark') }}: {{ currentViewEvent.data.remark || '-' }}
            </p>
          </span>
      </div>
      <!--      <pre>{{currentViewEvent.data}}</pre>-->
      <div class="mt-5 flex justify-end">
        <!--    EXTERNAL LIVE-->
        <vs-button v-if="currentViewEvent && currentViewEvent.data && currentViewEvent.data.externalLink"
                   :disabled="!currentViewEvent.canViewLiveClass"
                   class="mr-2"
                   color="success" icon="icon-link"
                   icon-pack="feather"
                   @click="goToExternalLink(currentViewEvent.data.externalLink)">
          {{ $t('live-class-schedule.go-to-external-link') }}
        </vs-button>

        <!--        <vs-button v-if="currentViewEvent && currentViewEvent.data && currentViewEvent.data.externalPassword"
                           icon-pack="feather" icon="icon-copy"
                           :disabled="!currentViewEvent.canViewLiveClass"
                           v-clipboard:copy="currentViewEvent.data.externalPassword"
                           v-clipboard:success="onCopy">
                  {{ $t('live-class-schedule.copy-password') }}
                </vs-button>-->

      </div>

    </vx-card>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {CalendarView, /*CalendarViewHeader*/} from "vue-simple-calendar"
import moduleCalendar from '@/store/modules/liveschedule/moduleCalendar.js'

require("vue-simple-calendar/static/css/default.css")

import {en, he} from "vuejs-datepicker/src/locale"
import {showLocalNotification, notificationType} from "@/utils/notification";
import store from "@/store";
import AdvisorOnlineSchedule from '@/store/modules/advisor-online-schedule/index';
import {createNamespacedHelpers} from "vuex";

if (!store.state.AdvisorOnlineSchedule) store.state.registerModule(`AdvisorOnlineSchedule`, AdvisorOnlineSchedule);
const {
  mapActions: mapAdvisorOnlineScheduleActions,
} = createNamespacedHelpers(`AdvisorOnlineSchedule`);

export default {
  components: {
    CalendarView,
    // CalendarViewHeader,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  data() {
    return {
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      currentViewEvent: {
        id: 0,
        title: '',
        startDate: '',
        endDate: '',
        labelLocal: 'none',
        data: {},
      },
      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,
      activeViewEvent: false,

      calendarViewTypes: [
        {
          label: "Week",
          i18n: "general.time.week",
          val: "week"
        },
        {
          label: "Month",
          i18n: "general.time.month",
          val: "month"
        },
        {
          label: "Year",
          i18n: "general.time.year",
          val: "year"
        },
      ],
      calendarEvents: [],
      processing: true,
    }
  },
  computed: {
    calendarEventList() {
      return this.calendarEvents;
    },
    validForm() {
      return this.title !== ''
        && this.startDate !== ''
        && this.endDate !== ''
        && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0
        && !this.errors.has('event-url');
    },
    disabledDatesTo() {
      return {to: new Date(this.startDate)}
    },
    disabledDatesFrom() {
      return {from: new Date(this.endDate)}
    },
    calendarLabels() {
      return this.$store.state.calendar.eventLabels
    },
    labelColor() {
      return (label) => {
        if (label === "business") return "success"
        else if (label === "work") return "warning"
        if (label === "personal") return "danger"
        if (label === "none") return "primary"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    showDateFormat() {
      moment.locale(this.$i18n.locale);
      return moment(this.showDate);
    }
  },
  methods: {
    ...mapAdvisorOnlineScheduleActions({
      getAdvisorOnlineSchedulesCurrentUser: 'getAdvisorOnlineSchedulesCurrentUser',
    }),
    addEvent() {
      const obj = {
        title: this.title,
        startDate: this.startDate,
        endDate: this.endDate,
        label: this.labelLocal,
        url: this.url
      }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
      this.title = this.endDate = this.url = "";
      this.id = 0;
      this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
      this.disabledFrom = false;
      this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
      this.clearFields();
      this.startDate = date;
      this.endDate = date;
      this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
      this.disabledFrom = true;
      this.addNewEventDialog(date);
    },
    openEvent(evt) {
      this.currentViewEvent = evt.originalEvent;
      this.activeViewEvent = true;
      setTimeout(() => {
        this.scrollToElement();
      }, 100)
    },
    closeEventViewer() {
      this.activeViewEvent = false;
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true;
    },
    editEvent() {
      const obj = {
        id: this.id,
        title: this.title,
        startDate: this.startDate,
        endDate: this.endDate,
        label: this.labelLocal,
        url: this.url
      }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    mapAdvisorOnlineSchedulesToCalendar(advisorOnlineSchedules) {

      moment.locale(this.$i18n.locale);

      return advisorOnlineSchedules.map(item => {
        const startDate = moment(new Date(item.dateTimeFrom));
        const endDate = moment(new Date(item.dateTimeTo));
        return {
          id: item.id,
          startDate: startDate,
          endDate: endDate,
          startDateFormat: startDate.format("LLLL"),
          endDateFormat: endDate.format("HH:mm"),
          title: item.subjectCode,
          url: '',
          classes: '',
          data: item,
          canViewLiveClass: moment().isSameOrBefore(endDate)
        }
      })
    },
    goToExternalLink(link) {
      window.open(link, '_blank');
    },
    onCopy() {
      showLocalNotification(this.$vs
        , this.$t('general.success'),
        this.$t('live-class-schedule.copy-success')
        , notificationType.SUCCESS);

    },
    cancel() {
      this.activeViewEvent = false;
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0];

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    async loadData() {
      this.processing = true;
      const result = await this.getAdvisorOnlineSchedulesCurrentUser();
      if (result) {
        this.calendarEvents = this.mapAdvisorOnlineSchedulesToCalendar(result);
        this.processing = false;
      }
    }
  },
  created() {
    this.$store.registerModule('calendar', moduleCalendar)
  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  },
  async beforeMount() {
    await this.loadData();
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
